
import * as React from 'react';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Button, IButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import strings from './ConfirmationDialog.resx';

/**
 * @internal
 */
export interface IConfirmationDialogProps {
  title: string;
  prompt: React.ReactNode;
  yesText?: React.ReactNode;
  noText?: React.ReactNode;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

/**
 * @internal
 */
export const ConfirmationDialog: React.StatelessComponent<IConfirmationDialogProps> = (props: IConfirmationDialogProps) => {
  const {
    onConfirm,
    onCancel,
    yesText = strings.yes,
    noText = strings.no
  } = props;

  const onNoRef = (button: IButton | null) => {
    if (button) {
      button.focus();
    }
  };

  return (
    <Dialog
      onDismiss={ onCancel }
      isOpen={ true }
      title={ props.title }
    >
      <Label>{ props.prompt }</Label>
      <DialogFooter>
        <Button
          onClick={ onConfirm }
        >
          { yesText }
        </Button>
        <Button
          onClick={ onCancel }
          primary={ true }
          componentRef={ onNoRef }
        >
          { noText }
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
